import { Rule } from 'antd/lib/form';

export const PASSWORD_VALIDATION: Rule[] = [
  { required: true, message: 'Password is required!' },
];
